import {flatten, map, transform, isEmpty} from 'lodash'

export function narrowDynamicItems(dynamicItems, docItems) {
  const ids = docItems.map(item => item.id)

  return transform(dynamicItems, (result, value, key) => {
    if (ids.includes(key)) {
      return result[key] = value
    }
  }, {})
}

export function compactDynamicItems(content) {
  const {metadata: {dynamicItems: oldDynamicItems} = {}, powtoon: {slides}} = content

  if (isEmpty(oldDynamicItems)){
    return oldDynamicItems
  }

  const allTracks = flatten(map(slides, 'tracks'))
  const allSprites = flatten(map(allTracks, 'sprites'))

  return narrowDynamicItems(oldDynamicItems, [...slides, ...allTracks, ...allSprites])
}
